<template>
  <div>
    <validation-observer ref="observer" method="post">
      <div
        :class="{ 'section-wrapper mt-md-5 pb-4': !isNosyaOnly }"
        v-if="isNosyaOnly || isHikitoriAA || isNosyaAA"
      >
        <section id="order-auction">
          <div class="row mx-auto">
            <div v-if="!isNosyaOnly" class="col-md-6">
              <h4 class="_page-sub-title pl-2 pl-md-4 mb-1">
                引取オークション情報
              </h4>
              <table class="table" v-if="isHikitoriAA">
                <tbody>
                  <tr>
                    <th>ワンプラ落札</th>
                    <td>
                      <div class="ml-2 ml-md-4">
                        <md-checkbox
                          ref="HIKITORI_AA_WANPULA_FLG"
                          class="form-check-input md-primary"
                          v-model="form.HIKITORI_AA_WANPULA_FLG"
                          :true-value="1"
                          :false-value="0"
                          @change="setHikiDaikoGyosyaPosBango"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr v-if="Number(form.HIKITORI_AA_WANPULA_FLG)">
                    <th>
                      落札日
                      <span class="must">必須</span>
                    </th>
                    <td>
                      <validation-provider
                        name="HIKITORI_AA_WANPULA_RAKUSATU_BI"
                        v-slot="{ errors }"
                        rules="required|date"
                      >
                        <DatePicker
                          ref="HIKITORI_AA_WANPULA_RAKUSATU_BI"
                          clearable
                          :class="['col-md-6', { 'border-red': errors.length }]"
                          placeholder="2019/01/01"
                          v-model="hikitoriAAWanpulaRakusatubi"
                        />
                        <div
                          v-if="errors.length"
                          class="ml-3 invalid-feedback"
                          style="display: block"
                        >
                          <span class="border-red">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </td>
                  </tr>
                  <tr v-else>
                    <th>
                      開催日
                      <span class="must">必須</span>
                    </th>
                    <td>
                      <validation-provider
                        name="HIKITORI_AA_KAISAI_BI"
                        v-slot="{ errors }"
                        rules="required|date"
                      >
                        <DatePicker
                          ref="HIKITORI_AA_KAISAI_BI"
                          clearable
                          :class="['col-md-6', { 'border-red': errors.length }]"
                          placeholder="2019/01/01"
                          v-model="hikitoriAAKaisaibi"
                        />
                        <div
                          v-if="errors.length"
                          class="ml-3 invalid-feedback"
                          style="display: block"
                        >
                          <span class="border-red">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </td>
                  </tr>
                  <tr>
                    <th>流札車両</th>
                    <td>
                      <div class="ml-2 ml-md-4">
                        <md-checkbox
                          ref="HIKITORI_AA_RYUSATU_SYARYO"
                          class="form-check-input md-primary"
                          v-model="form.HIKITORI_AA_RYUSATU_SYARYO"
                          :true-value="1"
                          :false-value="0"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      入金状況
                      <span class="must">必須</span>
                    </th>
                    <td>
                      <validation-provider
                        name="HIKITORI_AA_NYUKIN_JYOKYO_KBN"
                        v-slot="{ errors }"
                        rules="required"
                      >
                        <b-form-select
                          ref="HIKITORI_AA_NYUKIN_JYOKYO_KBN"
                          v-model="form.HIKITORI_AA_NYUKIN_JYOKYO_KBN"
                          :state="errors.length ? false : null"
                          :options="aaNyukinJyokyoKbnList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </td>
                  </tr>
                  <tr v-if="Number(form.HIKITORI_AA_NYUKIN_JYOKYO_KBN) === 3">
                    <th>
                      入金予定日
                      <br />
                      <span class="must">必須</span>
                    </th>
                    <td>
                      <div class="row mx-auto">
                        <div class="col-md-7 px-0 pr-md-2">
                          <validation-provider
                            name="HIKITORI_AA_NYUKIN_YOTEI_BI"
                            v-slot="{ errors }"
                            rules="required|date"
                          >
                            <DatePicker
                              ref="HIKITORI_AA_NYUKIN_YOTEI_BI"
                              clearable
                              :class="[{ 'border-red': errors.length }]"
                              placeholder="2019/01/01"
                              v-model="hikitoriAANyukinYoteibi"
                            />
                            <div
                              v-if="errors.length"
                              class="invalid-feedback"
                              style="display: block"
                            >
                              <span class="border-red">{{ errors[0] }}</span>
                            </div>
                          </validation-provider>
                        </div>

                        <div class="col-md-5 mt-2 mt-sm-0 px-0">
                          <validation-provider
                            name="HIKITORI_AA_NYUKIN_YOTEI_JIKAN"
                            v-slot="{ errors }"
                            rules="required"
                          >
                            <b-form-select
                              ref="HIKITORI_AA_NYUKIN_YOTEI_JIKAN"
                              v-model="form.HIKITORI_AA_NYUKIN_YOTEI_JIKAN"
                              :state="errors.length ? false : null"
                              :options="ampmList"
                              trim
                            />
                            <b-form-invalid-feedback>
                              <span class="border-red">{{ errors[0] }}</span>
                            </b-form-invalid-feedback>
                          </validation-provider>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="bg-white text-center py-3">入力不要です。</div>
            </div>

            <div
              :class="{ 'col-md-6 right-side': !isNosyaOnly }"
              v-if="isHikitoriAA || isNosyaAA"
            >
              <h4 class="_page-sub-title pl-2 pl-md-4 mb-1 pt-4 pt-md-0">
                納車オークション情報
              </h4>
              <table class="table" v-if="isNosyaOnly || isNosyaAA">
                <tbody>
                  <tr>
                    <th>
                      開催日
                      <span class="must">必須</span>
                    </th>
                    <td>
                      <validation-provider
                        name="NOSYA_AA_KAISAI_BI"
                        v-slot="{ errors }"
                        rules="required|date"
                      >
                        <DatePicker
                          ref="NOSYA_AA_KAISAI_BI"
                          clearable
                          :class="['col-md-6', { 'border-red': errors.length }]"
                          placeholder="2019/01/01"
                          v-model="nosyaAAKaisaibi"
                        />
                        <div
                          v-if="errors.length"
                          class="ml-3 invalid-feedback"
                          style="display: block"
                        >
                          <span class="border-red">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="bg-white text-center py-3">入力不要です。</div>
            </div>
          </div>

          <div class="row mx-auto">
            <div v-if="!isNosyaOnly" class="col-md-6">
              <h4 class="_page-sub-title pl-2 pl-md-4 mb-1" v-if="isHikitoriAA">
                <div class="row">
                  <div class="col-4 pt-3 pr-0">引取POS情報</div>
                  <div class="col-8 text-right">
                    <md-button
                      class="md-primary md-raised"
                      @click="
                        showPosListDialog = true
                        flgHNv = 'HIKITORI'
                        setSearchPosCond()
                        getAAList()
                        getPos()
                      "
                    >
                      登録済みのPOSから選択
                    </md-button>
                  </div>
                </div>
              </h4>
              <table class="table" v-if="isHikitoriAA">
                <tbody>
                  <tr>
                    <th>
                      POS種別（会員種別）
                      <span class="must">必須</span>
                    </th>
                    <td>
                      <validation-provider
                        name="HIKITORI_AA_POS_KBN"
                        vid="HIKITORI_AA_POS_KBN"
                        v-slot="{ errors }"
                        :rules="`required`"
                      >
                        <b-form-radio-group
                          ref="HIKITORI_AA_POS_KBN"
                          v-model="form.HIKITORI_AA_POS_KBN"
                          :state="errors.length ? false : null"
                          :options="posKbnList"
                          @change="
                            form.HIKITORI_AA_POS_BANGO = null
                            form.HIKITORI_AA_POS_MEIGI_INFO = null
                            form.HIKITORI_AA_POS_DAIKO_GYOSHA_MEI = null
                            setHikiDaikoGyosyaPosBango()
                            setPos(hikiAaCd, 'HIKITORI')
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                      <p
                        class="mt-2 red f-size-14"
                        v-show="isRequiredHansyutuken"
                      >
                        ※搬出券を必ず添付してください
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>代行業社名</th>
                    <td>
                      <validation-provider
                        name="HIKITORI_AA_POS_DAIKO_GYOSHA_MEI"
                        v-slot="{ errors }"
                        rules="max:20|char"
                      >
                        <b-form-input
                          ref="HIKITORI_AA_POS_DAIKO_GYOSHA_MEI"
                          maxlength="20"
                          v-model="form.HIKITORI_AA_POS_DAIKO_GYOSHA_MEI"
                          :state="errors.length ? false : null"
                          placeholder="自由入力"
                          trim
                          :disabled="form.HIKITORI_AA_POS_KBN !== 9"
                          @blur="
                            form.HIKITORI_AA_POS_DAIKO_GYOSHA_MEI = replaceChar(
                              form.HIKITORI_AA_POS_DAIKO_GYOSHA_MEI
                            )
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      名義情報
                      <span class="must" v-if="form.HIKITORI_AA_POS_KBN !== 3">
                        必須
                      </span>
                    </th>
                    <td>
                      <validation-provider
                        name="HIKITORI_AA_POS_MEIGI_INFO"
                        v-slot="{ errors }"
                        rules="required|max:20|char"
                      >
                        <b-form-input
                          ref="HIKITORI_AA_POS_MEIGI_INFO"
                          maxlength="20"
                          v-model="form.HIKITORI_AA_POS_MEIGI_INFO"
                          :state="errors.length ? false : null"
                          placeholder="自由入力"
                          trim
                          @blur="
                            form.HIKITORI_AA_POS_MEIGI_INFO = replaceChar(
                              form.HIKITORI_AA_POS_MEIGI_INFO
                            )
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      POS番号（会員番号）
                      <span class="must" v-if="form.HIKITORI_AA_POS_KBN !== 3">
                        必須
                      </span>
                    </th>
                    <td>
                      <validation-provider
                        name="HIKITORI_AA_POS_BANGO"
                        v-slot="{ errors }"
                        rules="required_if:HIKITORI_AA_POS_KBN,1,2,4,5,9|max:20|hanAlphaNumKigo"
                      >
                        <b-form-input
                          ref="HIKITORI_AA_POS_BANGO"
                          maxlength="20"
                          v-model="form.HIKITORI_AA_POS_BANGO"
                          :state="errors.length ? false : null"
                          placeholder="123456"
                          trim
                          @blur="
                            form.HIKITORI_AA_POS_BANGO = hankaku2Zenkaku(
                              form.HIKITORI_AA_POS_BANGO
                            )
                          "
                          :disabled="form.HIKITORI_AA_POS_KBN === 3"
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              :class="{ 'col-md-6 right-side': !isNosyaOnly }"
              v-if="isHikitoriAA || isNosyaAA"
            >
              <h4
                class="_page-sub-title pl-2 pl-md-4 mb-1"
                v-if="isNosyaOnly || isNosyaAA"
              >
                <div class="row">
                  <div class="col-4 pt-3 pr-0">納車POS情報</div>
                  <div class="col-8 text-right">
                    <md-button
                      class="md-primary md-raised"
                      @click="
                        showPosListDialog = true
                        flgHNv = 'NOSYA'
                        setSearchPosCond()
                        getAAList()
                        getPos()
                      "
                    >
                      登録済みのPOSから選択
                    </md-button>
                  </div>
                </div>
              </h4>
              <table class="table" v-if="isNosyaOnly || isNosyaAA">
                <tbody>
                  <tr>
                    <th>
                      POS種別（会員種別）
                      <span class="must">必須</span>
                    </th>
                    <td>
                      <validation-provider
                        name="NOSYA_AA_POS_KBN"
                        vid="NOSYA_AA_POS_KBN"
                        v-slot="{ errors }"
                        :rules="`required`"
                      >
                        <b-form-radio-group
                          ref="NOSYA_AA_POS_KBN"
                          v-model="form.NOSYA_AA_POS_KBN"
                          :state="errors.length ? false : null"
                          :options="posKbnList"
                          @change="
                            form.NOSYA_AA_POS_BANGO = null
                            form.NOSYA_AA_POS_MEIGI_INFO = null
                            form.NOSYA_AA_POS_DAIKO_GYOSHA_MEI = null
                            setPos(nosyaAaCd, 'NOSYA')
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </td>
                  </tr>
                  <tr>
                    <th>代行業社名</th>
                    <td>
                      <validation-provider
                        name="NOSYA_AA_POS_DAIKO_GYOSHA_MEI"
                        v-slot="{ errors }"
                        rules="max:20|char"
                      >
                        <b-form-input
                          ref="NOSYA_AA_POS_DAIKO_GYOSHA_MEI"
                          maxlength="20"
                          v-model="form.NOSYA_AA_POS_DAIKO_GYOSHA_MEI"
                          :state="errors.length ? false : null"
                          placeholder="自由入力"
                          trim
                          :disabled="form.NOSYA_AA_POS_KBN !== 9"
                          @blur="
                            form.NOSYA_AA_POS_DAIKO_GYOSHA_MEI = replaceChar(
                              form.NOSYA_AA_POS_DAIKO_GYOSHA_MEI
                            )
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      名義情報
                      <span class="must" v-if="form.NOSYA_AA_POS_KBN !== 3">
                        必須
                      </span>
                    </th>
                    <td>
                      <validation-provider
                        name="NOSYA_AA_POS_MEIGI_INFO"
                        v-slot="{ errors }"
                        rules="required|max:20|char"
                      >
                        <b-form-input
                          ref="NOSYA_AA_POS_MEIGI_INFO"
                          maxlength="20"
                          v-model="form.NOSYA_AA_POS_MEIGI_INFO"
                          :state="errors.length ? false : null"
                          placeholder="自由入力"
                          trim
                          @blur="
                            form.NOSYA_AA_POS_MEIGI_INFO = replaceChar(
                              form.NOSYA_AA_POS_MEIGI_INFO
                            )
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      POS番号（会員番号）
                      <span class="must" v-if="form.NOSYA_AA_POS_KBN !== 3">
                        必須
                      </span>
                    </th>
                    <td>
                      <validation-provider
                        name="NOSYA_AA_POS_BANGO"
                        v-slot="{ errors }"
                        rules="required_if:NOSYA_AA_POS_KBN,1,2,4,5,9|max:20|hanAlphaNumKigo"
                      >
                        <b-form-input
                          ref="NOSYA_AA_POS_BANGO"
                          v-model="form.NOSYA_AA_POS_BANGO"
                          :state="errors.length ? false : null"
                          placeholder="123456"
                          trim
                          max-length="20"
                          @blur="
                            form.NOSYA_AA_POS_BANGO = hankaku2Zenkaku(
                              form.NOSYA_AA_POS_BANGO
                            )
                          "
                          :disabled="form.NOSYA_AA_POS_KBN === 3"
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>

      <div :class="{ 'section-wrapper mt-md-5 pb-4': !isNosyaOnly }">
        <section id="order-hansyutu">
          <div class="row mx-auto">
            <div v-if="!isNosyaOnly" class="col-md-6 p-2">
              <h4 class="_page-sub-title pl-2 pl-md-4 mb-1">
                <span v-if="isLease">引取希望日</span>
                <span v-else>搬出希望日</span>
              </h4>
              <table class="table">
                <tr>
                  <th>
                    <span v-if="isLease">引取希望日</span>
                    <span v-else>搬出希望日</span>
                    <span
                      v-if="!isLease && !Number(_form.HIKITORI_AA_FLG)"
                      class="must"
                    >
                      必須
                    </span>
                  </th>
                  <td>
                    <validation-provider
                      name="HANSYUTU_KIBOU_BI"
                      v-slot="{ errors }"
                      :rules="`${
                        !isLease && !Number(_form.HIKITORI_AA_FLG)
                          ? 'required|'
                          : ''
                      }date`"
                    >
                      <DatePicker
                        ref="HANSYUTU_KIBOU_BI"
                        clearable
                        :class="['col-md-6', { 'border-red': errors.length }]"
                        placeholder="2019/01/01"
                        v-model="hansyutuKiboubi"
                        :disabled-date="disabledDate"
                      />
                      <div
                        v-if="errors.length"
                        class="ml-3 invalid-feedback"
                        style="display: block"
                      >
                        <span class="border-red">{{ errors[0] }}</span>
                      </div>
                    </validation-provider>
                    <p v-if="isLease" class="mt-2 red f-size-12">
                      ※指定がない場合はロジコ側でお客様と日程を調整させていただきます
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>
                    <span v-if="isLease">引取</span>
                    <span v-else>搬出</span>
                    前の事前連絡を希望する
                  </th>
                  <td>
                    <div class="ml-4 mt-2">
                      <md-checkbox
                        ref="HANSYUTU_JIZEN_RENRAKU_FLG"
                        class="form-check-input md-primary"
                        v-model="form.HANSYUTU_JIZEN_RENRAKU_FLG"
                        :true-value="1"
                        :false-value="0"
                      >
                        希望する
                      </md-checkbox>
                    </div>
                  </td>
                </tr>
              </table>
            </div>

            <div :class="{ 'col-md-6 right-side p-2': !isNosyaOnly }">
              <h4
                :class="[
                  '_page-sub-title pl-2 pl-md-4 mb-1 pt-4 pt-md-0',
                  { 'pt-md-2': isNosyaOnly },
                ]"
              >
                <span v-if="isLease">納車希望日</span>
                <span v-else>搬入希望日</span>
              </h4>
              <table class="table">
                <tr>
                  <th>
                    <span v-if="isLease">納車希望日</span>
                    <span v-else>搬入希望日</span>
                    <span v-if="!isLease" class="must">必須</span>
                  </th>
                  <td>
                    <validation-provider
                      name="HANNYU_KIBOU_BI"
                      v-slot="{ errors }"
                      :rules="`${!isLease ? 'required|' : ''}date`"
                    >
                      <DatePicker
                        ref="HANNYU_KIBOU_BI"
                        clearable
                        :class="['col-md-6', { 'border-red': errors.length }]"
                        placeholder="2019/01/01"
                        v-model="hannyuKiboubi"
                        :disabled-date="disabledDate"
                      />
                      <div
                        v-if="errors.length"
                        class="ml-3 invalid-feedback"
                        style="display: block"
                      >
                        <span class="border-red">{{ errors[0] }}</span>
                      </div>
                    </validation-provider>
                    <div class="mt-2 red f-size-12">
                      <p v-show="isMeihen && isNosyaSaturday">
                        ※土曜日対応はお見積りに別途15,000円加算されます
                      </p>
                      <p v-if="isLease">
                        ※指定がない場合はロジコ側でお客様と日程を調整させていただきます
                      </p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <span v-if="isLease">納車</span>
                    <span v-else>搬入</span>
                    前の事前連絡を希望する
                  </th>
                  <td>
                    <div class="ml-4 mt-2">
                      <md-checkbox
                        style="position: relative"
                        ref="HANNYU_JIZEN_RENRAKU_FLG"
                        class="form-check-input md-primary"
                        v-model="form.HANNYU_JIZEN_RENRAKU_FLG"
                        :true-value="1"
                        :false-value="0"
                      >
                        希望する
                      </md-checkbox>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </section>
      </div>

      <div :class="{ 'section-wrapper mt-md-5 pb-4': !isNosyaOnly }">
        <section id="order-remark">
          <div class="row mx-auto">
            <div v-if="!isNosyaOnly" class="col-md-6 p-2">
              <h4 class="_page-sub-title pl-2 pl-md-4 mb-1">
                <div class="row">
                  <div class="col-4 pt-3 pr-0">引取備考</div>
                  <div class="col-8 text-right">
                    <md-button
                      class="md-primary md-raised"
                      @click="
                        showDialog_trans2 = true
                        flgHNv = 'HIKITORI'
                        getTemplate()
                      "
                    >
                      テンプレートから選択
                    </md-button>
                  </div>
                </div>
              </h4>
              <table class="table">
                <tr>
                  <th>備考</th>
                  <td>
                    <validation-provider
                      name="HIKITORI_BIKOU"
                      v-slot="{ errors }"
                      rules="max:160|char"
                    >
                      <b-form-textarea
                        ref="HIKITORI_BIKOU"
                        maxlength="160"
                        rows="5"
                        v-model="form.HIKITORI_BIKOU"
                        :state="errors.length ? false : null"
                        trim
                        @blur="
                          form.HIKITORI_BIKOU = replaceChar(form.HIKITORI_BIKOU)
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </td>
                </tr>
              </table>
              <div class="text-right sp-fs-12">
                {{ form.HIKITORI_BIKOU ? form.HIKITORI_BIKOU.length : 0 }}/160
              </div>
            </div>

            <div :class="{ 'col-md-6 p-2': !isNosyaOnly }">
              <h4 class="_page-sub-title pl-2 pl-md-4 mb-1">
                <div class="row">
                  <div class="col-4 pt-3 pr-0">納車備考</div>
                  <div class="col-8 text-right">
                    <md-button
                      class="md-primary md-raised"
                      @click="
                        showDialog_trans2 = true
                        flgHNv = 'NOSYA'
                        getTemplate()
                      "
                    >
                      テンプレートから選択
                    </md-button>
                  </div>
                </div>
              </h4>
              <table class="table">
                <tr>
                  <th>備考</th>
                  <td>
                    <validation-provider
                      name="NOSYA_BIKOU"
                      v-slot="{ errors }"
                      rules="max:160|char"
                    >
                      <b-form-textarea
                        ref="NOSYA_BIKOU"
                        maxlength="160"
                        rows="5"
                        v-model="form.NOSYA_BIKOU"
                        :state="errors.length ? false : null"
                        trim
                        @blur="form.NOSYA_BIKOU = replaceChar(form.NOSYA_BIKOU)"
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </td>
                </tr>
              </table>
              <div class="text-right sp-fs-12">
                {{ form.NOSYA_BIKOU ? form.NOSYA_BIKOU.length : 0 }}/160
              </div>
            </div>
          </div>
        </section>
      </div>
    </validation-observer>

    <!-- 備考一覧モーダル -->
    <md-dialog
      :md-active.sync="showDialog_trans2"
      class="new w-800"
      :md-fullscreen="false"
      @md-opened="
        $refs.templateObserver.reset()
        scroll('locked')
      "
      @md-closed="scroll('clear')"
    >
      <md-dialog-title>テンプレート一覧</md-dialog-title>
      <div class="p-3 p-md-4">
        <div class="ml-md-3 mb-3 search-wrapper">
          <div>
            <label class="d-md-inline pt-2 col-md-4 text-left px-0 my-0">
              検索文字
            </label>
            <input
              type="text"
              class="d-md-inline form-control col-md-8"
              v-model="searchTxt"
              @change="getTemplate()"
            />
          </div>
        </div>

        <div class="text-right mx-2 mx-md-4 mb-1">
          <b-button
            class="d-inline btn btn-primary sp-fs-14"
            @click="
              showDialog_trans2 = false
              createTemplate()
            "
          >
            新規
          </b-button>
          <b-button
            class="d-inline btn btn-success sp-fs-14"
            @click="editTemplate()"
            :disabled="!selectedObj"
          >
            編集
          </b-button>
          <b-button
            class="d-inline btn sp-fs-14"
            @click="showDeleteTemplateConfirm = true"
            :disabled="!selectedObj"
          >
            削除
          </b-button>
        </div>

        <section id="order-template">
          <div v-if="async.messages" class="spinner my-5">
            <md-progress-spinner md-mode="indeterminate" />
          </div>
          <div v-else>
            <md-table
              v-if="messages.length"
              class="black-svg h-300 checkbox"
              v-model="messages"
              md-sort="template"
              md-sort-order="asc"
              md-card
              md-fixed-header
            >
              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
                @click="selectTemplate(item)"
                :class="getTableRowClass(item)"
              >
                <md-table-cell v-if="!isMobile" md-label="">
                  <input
                    type="radio"
                    :id="item.id"
                    :value="item.id"
                    v-model="picked"
                  />
                </md-table-cell>
                <md-table-cell md-label="メッセージ" md-sort-by="template">
                  <span v-if="!isMobile">
                    {{ omitText(item.template, 50) }}
                  </span>
                  <div v-else>
                    <input
                      class="d-inline"
                      type="radio"
                      :id="item.id"
                      :value="item.id"
                      v-model="picked"
                    />
                    <p class="d-inline ml-2">
                      {{ _omitText(item.template, 28) }}
                    </p>
                  </div>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div v-else class="text-center my-5 bold">
              該当データがありません。
            </div>
          </div>
        </section>

        <md-dialog-actions>
          <md-button class="md-primary" @click="showDialog_trans2 = false">
            閉じる
          </md-button>
          <md-button class="md-primary" @click="decideTemplate()">
            決定
          </md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <!-- 備考登録モーダル -->
    <validation-observer ref="templateObserver" method="post">
      <md-dialog
        :md-active.sync="showDialog_trans3"
        class="new w-800"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>テンプレート登録</md-dialog-title>
        <div class="p-4">
          <validation-provider
            v-slot="{ errors }"
            rules="required|max:160|char"
          >
            <b-form-textarea
              maxlength="160"
              rows="5"
              v-model="template.TEMPLATE_TEMPLATE"
              :state="errors.length ? false : null"
              trim
              @blur="
                template.TEMPLATE_TEMPLATE = replaceChar(
                  template.TEMPLATE_TEMPLATE
                )
              "
            />
            <b-form-invalid-feedback>
              <span class="border-red">{{ errors[0] }}</span>
            </b-form-invalid-feedback>
          </validation-provider>
          <div class="text-right sp-fs-12">
            {{ template.TEMPLATE_TEMPLATE.length }}/160
          </div>
          <md-dialog-actions>
            <md-button
              class="md-primary"
              @click="
                showDialog_trans3 = false
                showDialog_trans2 = true
              "
            >
              閉じる
            </md-button>
            <md-button class="md-primary" @click="setTemplate">登録</md-button>
          </md-dialog-actions>
        </div>
      </md-dialog>
    </validation-observer>

    <!-- 備考削除確認 -->
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="showDeleteTemplateConfirm"
      md-title=""
      md-content="<strong>削除してもよろしいですか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="deleteTemplate()"
    />

    <!-- POS番号一覧モーダル -->
    <md-dialog
      :md-active.sync="showPosListDialog"
      class="new w-800"
      :md-fullscreen="false"
      @md-opened="
        $refs.posObserver.reset()
        scroll('locked')
      "
      @md-closed="scroll('clear')"
    >
      <md-dialog-title>POS番号（会員番号）一覧</md-dialog-title>
      <div class="p-3 p-md-4">
        <div class="ml-md-3 mb-3 search-wrapper">
          <div>
            <label class="d-md-inline pt-2 col-md-4 text-left px-0 my-0">
              都道府県
            </label>
            <b-form-select
              v-model="selectedPosTodoCd"
              :options="prefList"
              trim
              class="d-md-inline form-control col-md-2 mr-3"
              @change="
                selectedPosAaCd = null
                getAAList()
                getPos()
              "
            />
            <label class="d-md-inline pt-2 col-md-4 text-left px-0 my-0">
              オークション会場
            </label>
            <b-form-select
              v-model="selectedPosAaCd"
              :options="aaList"
              :disabled="!aaList.length"
              trim
              class="d-md-inline form-control col-md-6"
              @change="getPos"
            />
          </div>
        </div>
        <div class="text-right mx-2 mx-md-4 mb-1">
          <b-button
            class="d-inline btn btn-primary sp-fs-14"
            @click="selectedPos"
            :disabled="!selectedObj"
          >
            選択
          </b-button>
          <b-button class="d-inline btn btn-danger sp-fs-14" @click="addPos">
            追加
          </b-button>
          <b-button
            class="d-inline btn btn-success sp-fs-14"
            @click="editPos"
            :disabled="!selectedObj"
          >
            編集
          </b-button>
          <b-button
            class="d-inline btn sp-fs-14"
            @click="showDeletePosConfirmDialog = true"
            :disabled="!selectedObj"
          >
            削除
          </b-button>
        </div>

        <section id="pos-template">
          <div v-if="isLoadlingPosList" class="spinner my-5">
            <md-progress-spinner md-mode="indeterminate" />
          </div>
          <div v-else>
            <md-table
              v-if="posList.length"
              class="black-svg h-300 checkbox"
              v-model="posList"
              md-sort="POS_KBN"
              md-sort-order="asc"
              md-card
              md-fixed-header
            >
              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
                :class="getTableRowClass(item)"
                @click="
                  setTableRowClassAndName(item.ID, posList)
                  selectedPosDetailId = item.ID
                "
              >
                <md-table-cell v-if="!isMobile" md-label="">
                  <input
                    type="radio"
                    :id="item.id"
                    :value="item.ID"
                    v-model="selectedPosDetailId"
                  />
                </md-table-cell>
                <md-table-cell md-label="番号" md-sort-by="pos.POS_BANGO">
                  <span v-if="!isMobile">{{ item.pos.POS_BANGO }}</span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold">番号</p>
                    <p class="col-9 p-0">{{ item.pos.POS_BANGO }}</p>
                  </div>
                </md-table-cell>
                <md-table-cell md-label="種別" md-sort-by="POS_KBN">
                  <span v-if="!isMobile">
                    {{ getText(posKbnList, item.POS_KBN) }}
                  </span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold">種別</p>
                    <p class="col-9 p-0">
                      {{ getText(posKbnList, item.POS_KBN) }}
                    </p>
                  </div>
                </md-table-cell>
                <md-table-cell
                  md-label="代行業者名"
                  md-sort-by="DAIKO_GYOSHA_MEI"
                >
                  <span v-if="!isMobile">
                    {{ item.DAIKO_GYOSHA_MEI }}
                  </span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold">代行業者名</p>
                    <p class="col-9 p-0">
                      {{ item.DAIKO_GYOSHA_MEI }}
                    </p>
                  </div>
                </md-table-cell>
                <md-table-cell md-label="名義情報" md-sort-by="MEIGI_INFO">
                  <span v-if="!isMobile">
                    {{ item.MEIGI_INFO }}
                  </span>
                  <div v-else class="row">
                    <p class="col-3 p-0 bold">名義情報</p>
                    <p class="col-9 p-0">
                      {{ item.MEIGI_INFO }}
                    </p>
                  </div>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div v-else class="text-center my-5 bold">
              該当データがありません。
            </div>
          </div>
        </section>

        <md-dialog-actions>
          <md-button class="md-primary" @click="showPosListDialog = false">
            閉じる
          </md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <!-- POS番号情報編集モーダル -->
    <validation-observer ref="posObserver" method="post">
      <md-dialog
        :md-active.sync="showEditPosDialog"
        class="new w-800 edit_pos_dialog"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>POS番号情報編集</md-dialog-title>
        <div class="p-2 of-auto">
          <table class="table">
            <tbody>
              <tr v-if="editPosDetail && !editPosDetail.ID">
                <th>
                  オークション会場
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row mb-2">
                    <label class="d-inline mt-2 ml-3 pr-2">都道府県</label>
                    <validation-provider v-slot="{ errors }">
                      <b-form-select
                        v-model="toAddPos.aaTodoCd"
                        :state="errors.length ? false : null"
                        :options="prefList"
                        trim
                        @change="getAAListToAddPos"
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <div>
                    <validation-provider v-slot="{ errors }" rules="required">
                      <b-form-select
                        v-model="editPosDetail.pos.AA_CD"
                        :state="errors.length ? false : null"
                        :options="toAddPos.aaList"
                        :disabled="!toAddPos.aaList.length"
                        trim
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  POS種別（会員種別）
                  <span class="must">必須</span>
                </th>
                <td>
                  <validation-provider
                    name="POS_KBN"
                    v-slot="{ errors }"
                    :rules="`required`"
                  >
                    <b-form-radio-group
                      ref="POS_KBN"
                      v-model="editPosDetail.POS_KBN"
                      :state="errors.length ? false : null"
                      :options="modalPosKbnList"
                      @change="
                        if (editPosDetail.POS_KBN !== 9)
                          editPosDetail.DAIKO_GYOSHA_MEI = null
                      "
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>代行業社名</th>
                <td>
                  <validation-provider
                    name="DAIKO_GYOSHA_MEI"
                    v-slot="{ errors }"
                    rules="max:20|char"
                  >
                    <b-form-input
                      ref="DAIKO_GYOSHA_MEI"
                      maxlength="20"
                      v-model="editPosDetail.DAIKO_GYOSHA_MEI"
                      :state="errors.length ? false : null"
                      placeholder="自由入力"
                      trim
                      :disabled="editPosDetail.POS_KBN !== 9"
                      @blur="
                        editPosDetail.DAIKO_GYOSHA_MEI = replaceChar(
                          editPosDetail.DAIKO_GYOSHA_MEI
                        )
                      "
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>
                  名義情報
                  <span class="must">必須</span>
                </th>
                <td>
                  <validation-provider
                    name="MEIGI_INFO"
                    v-slot="{ errors }"
                    rules="required|max:20|char"
                  >
                    <b-form-input
                      ref="MEIGI_INFO"
                      maxlength="20"
                      v-model="editPosDetail.MEIGI_INFO"
                      :state="errors.length ? false : null"
                      placeholder="自由入力"
                      trim
                      @blur="
                        editPosDetail.MEIGI_INFO = replaceChar(
                          editPosDetail.MEIGI_INFO
                        )
                      "
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>
                  POS番号（会員番号）
                  <span class="must">必須</span>
                </th>
                <td>
                  <validation-provider
                    name="POS_BANGO"
                    v-slot="{ errors }"
                    rules="required|max:20|hanAlphaNumKigo"
                  >
                    <b-form-input
                      ref="POS_BANGO"
                      maxlength="20"
                      v-model="editPosDetail.pos.POS_BANGO"
                      :state="errors.length ? false : null"
                      placeholder="123456"
                      trim
                      @blur="
                        editPosDetail.pos.POS_BANGO = hankaku2Zenkaku(
                          editPosDetail.pos.POS_BANGO
                        )
                      "
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
            </tbody>
          </table>

          <md-dialog-actions>
            <md-button
              class="md-primary"
              @click="
                showEditPosDialog = false
                showPosListDialog = true
              "
            >
              閉じる
            </md-button>
            <md-button class="md-primary" @click="updatePos">登録</md-button>
          </md-dialog-actions>
        </div>
      </md-dialog>
    </validation-observer>

    <!-- POS番号情報削除確認 -->
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="showDeletePosConfirmDialog"
      md-title=""
      md-content="<strong>削除してもよろしいですか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="deletePos()"
    />
  </div>
</template>

<script>
import {POS_KBN} from '@/constants/posKbn'
import Store from '@/store/index.js'
import cloneDeep from 'lodash/cloneDeep'
import Mixin from '../mixin/Mixin'

export default {
  name: 'HikiNoDetail',

  mixins: [Mixin],

  components: {},

  props: {
    /** 親入力データ */
    _form: {
      type: Object,
      default: null,
    },

    /** 入力データ取得フラグ */
    isGetData: {
      type: Boolean,
      default: false,
    },

    /** 引取先がオークションか */
    isHikitoriAA: {
      type: Number,
      default: 0,
    },

    /** 納車先がオークションか */
    isNosyaAA: {
      type: Number,
      default: 0,
    },

    /** 納車先のみ表示フラグ */
    isNosyaOnly: {
      type: Boolean,
      default: false,
    },

    /** 入力データセットフラグ */
    isSetData: {
      type: Boolean,
      default: false,
    },

    /** 引取先オークションコード */
    hikiAaCd: {
      type: String,
      default: null,
    },

    /** 納車先オークションコード */
    nosyaAaCd: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    /** オブザーバー */
    observer: null,

    /** 入力データ */
    form: {
      HIKITORI_AA_KAISAI_BI: null,
      HIKITORI_AA_WANPULA_FLG: null,
      HIKITORI_AA_WANPULA_RAKUSATU_BI: null,
      HIKITORI_AA_RYUSATU_SYARYO: null,
      HIKITORI_AA_POS_BANGO: null,
      HIKITORI_AA_POS_DETAIL_ID: null,
      HIKITORI_AA_POS_KBN: 1,
      HIKITORI_AA_POS_RAKUSATU_SYUPPIN: 0,
      HIKITORI_AA_POS_DAIKO_GYOSHA_MEI: null,
      HIKITORI_AA_POS_MEIGI_INFO: null,
      HIKITORI_AA_NYUKIN_JYOKYO_KBN: '',
      HIKITORI_AA_NYUKIN_YOTEI_BI: null,
      HIKITORI_AA_NYUKIN_YOTEI_JIKAN: '',
      HANSYUTU_KIBOU_BI: null,
      HANSYUTU_JIZEN_RENRAKU_FLG: 0,
      HIKITORI_BIKOU: null,
      NOSYA_AA_KAISAI_BI: null,
      NOSYA_AA_POS_BANGO: null,
      NOSYA_AA_POS_DETAIL_ID: null,
      NOSYA_AA_POS_KBN: 1,
      NOSYA_AA_POS_RAKUSATU_SYUPPIN: 0,
      NOSYA_AA_POS_DAIKO_GYOSHA_MEI: null,
      NOSYA_AA_POS_MEIGI_INFO: null,
      NOSYA_AA_SYUPPIN_MEI: null,
      NOSYA_AA_KAIJYO_TANTO_MEI: null,
      HANNYU_KIBOU_BI: null,
      HANNYU_JIZEN_RENRAKU_FLG: 0,
      NOSYA_BIKOU: null,
    },

    /** Pos追加用オークション */
    toAddPos: {
      aaTodoCd: null,
      aaList: [],
    },

    /** 以下備考系 */
    messages: [],
    searchTxt: '',
    showDialog_trans2: false,
    showDialog_trans3: false,
    showDeleteTemplateConfirm: false,
    transport: [],
    async: {
      messages: false,
    },
    template: {
      TEMPLATE_ID: '',
      TEMPLATE_HUM_TANTO_ID: '',
      TEMPLATE_TEMPLATE: '',
    },
    /** POS番号情報 */
    showPosListDialog: false,
    showEditPosDialog: false,
    showDeletePosConfirmDialog: false,
    isLoadlingPosList: false,
    aaList: [],
    posAaList: [],
    posList: [],
    editPosDetail: null,
    selectedPosDetailId: null,
    selectedPosAaCd: null,
    selectedPosTodoCd: null,
    hiddenPosParams: {
      HIKITORI_AA_POS_DETAIL_ID: null,
      HIKITORI_AA_POS_RAKUSATU_SYUPPIN: 0,
      NOSYA_AA_POS_DETAIL_ID: null,
      NOSYA_AA_POS_RAKUSATU_SYUPPIN: 0,
    },
  }),

  mounted() {
    this.observer = this.$refs.observer
    if (this._form) this.makeForm()
  },

  methods: {
    /** 入力データを生成する */
    makeForm() {
      const data = {}
      for (var name in this.form) {
        data[name] = this._form[name] ? this._form[name] : this.form[name]
      }
      this.form = data
      this.getAAList().then(() => {
        this.posAaList = this.aaList
      })
    },

    /** 表示された入力データのみ設定する */
    cleanup() {
      let result = {}
      for (var name in this.form) {
        result[name] = this.$refs[name] ? this.form[name] : null
      }
      for (const name in this.hiddenPosParams) {
        result[name] = this.form[name] || this.hiddenPosParams[name]
      }
      return result
    },

    /** テンプレートの選択  */
    selectTemplate(item) {
      this.setTableRowClassAndName(item.id, this.messages)
      this.template.TEMPLATE_ID = item.id
      this.template.TEMPLATE_HUM_TANTO_ID = item.hum_tanto_id
      this.template.TEMPLATE_TEMPLATE = item.template
    },

    /** テンプレート一覧の取得 */
    getTemplate() {
      this.async.messages = true
      let keyword = this.searchTxt
      let tantoId = Store.state.user.data.ID
      return this.$store
        .dispatch('order/getTemplate', { tantoId, keyword })
        .then((res) => {
          this.messages = res.data
          this.async.messages = false
        })
        .catch((err) => {
          this.async.messages = false
          this._alert(err.message, false)
        })
    },

    /** テンプレートの編集 */
    editTemplate() {
      if (this.template.TEMPLATE_ID) {
        this.showDialog_trans2 = false
        this.showDialog_trans3 = true
      } else {
        this._alert('選択してください。', false)
      }
    },

    /** テンプレートの削除 */
    deleteTemplate() {
      if (this.template.TEMPLATE_ID) {
        return this.$store
          .dispatch('order/deleteTemplate', this.template)
          .then((res) => {
            this.getTemplate()
          })
          .catch((err) => {
            this._alert(err.message, false)
          })
      } else this._alert('選択してください。', false)
    },
    createTemplate() {
      this.template.TEMPLATE_ID = ''
      this.template.TEMPLATE_TEMPLATE = ''
      this.showDialog_trans3 = true
    },

    /** テンプレート登録 */
    async setTemplate() {
      this.spinerOff()

      if (!(await this.$refs.templateObserver.validate())) return

      this.showDialog_trans3 = false
      if (this.template.TEMPLATE_ID !== '') {
        return this.$store
          .dispatch('order/updateTemplate', this.template)
          .then((res) => {
            this.showDialog_trans2 = true
            this.getTemplate()
          })
          .catch((err) => {
            this._alert(err.message, false)
          })
      } else {
        return this.$store
          .dispatch('order/setTemplate', this.template)
          .then((res) => {
            this.showDialog_trans2 = true
            this.getTemplate()
          })
          .catch((err) => {
            this._alert(err.message, false)
          })
      }
    },

    /** テンプレートを備考に設定 */
    decideTemplate() {
      this.form[`${this.flgHNv}_BIKOU`] = this.template.TEMPLATE_TEMPLATE
      this.showDialog_trans2 = false
    },

    /** オークションリスト取得 */
    getAAList() {
      this.aaList = []
      const prefCd =
        this.selectedPosTodoCd !== '' ? this.selectedPosTodoCd : null
      return this.getAuctions(prefCd).then((res) => {
        this.aaList = res.data.map((v) => {
          return {
            value: v.AA_CD,
            text: v.name,
            AS_POS: v.AS_POS,
            AS_ONE_POS: v.AS_ONE_POS,
          }
        })
        this.aaList.unshift({ text: '未選択', value: null })
      })
    },

    /** pos追加用のオークションリスト取得 */
    getAAListToAddPos() {
      this.toAddPos.aaList = []
      this.editPosDetail.pos.AA_CD = null
      const prefCd =
        this.toAddPos.aaTodoCd !== '' ? this.toAddPos.aaTodoCd : null
      return this.getAuctions(prefCd).then((res) => {
        this.toAddPos.aaList = res.data.map((v) => {
          return {
            value: v.AA_CD,
            text: v.name,
          }
        })
        this.toAddPos.aaList.unshift({ text: '未選択', value: null })
      })
    },

    /** POS番号情報の削除 */
    deletePos() {
      if (this.selectedObj) {
        return this.$store
          .dispatch('order/deletePos', {
            id: this.selectedObj.pos.ID,
            detailId: this.selectedObj.ID,
          })
          .then((res) => {
            this.getPos()
          })
          .catch((err) => {
            this._alert(err.message, false)
          })
      } else this._alert('選択してください。', false)
    },

    /** POS番号情報の追加 */
    addPos() {
      this.editPosDetail = {
        ID: null,
        NAVI_POS_ID: null,
        RAKUSATU_SYUPPIN: this.flgHNv == 'HIKITORI' ? 2 : 1,
        POS_KBN: 1,
        DAIKO_GYOSHA_MEI: null,
        MEIGI_INFO: null,
        pos: {
          ID: null,
          JYUCYU_SHIKI_CD: Store.state.user.data.JYUCYU_SHIKI_CD,
          AA_CD: null,
          POS_BANGO: null,
        },
      }
      this.getAAListToAddPos()
      this.editPosDetail.pos.AA_CD =
        this.flgHNv == 'HIKITORI' ? this.hikiAaCd : this.nosyaAaCd
      this.showPosListDialog = false
      this.showEditPosDialog = true
    },

    /** POS番号情報の編集 */
    editPos() {
      if (this.selectedObj) {
        this.editPosDetail = cloneDeep(this.selectedObj)
        this.showPosListDialog = false
        this.showEditPosDialog = true
      } else {
        this._alert('選択してください。', false)
      }
    },

    /** POS番号一覧を設定 */
    getPos() {
      this.isLoadlingPosList = true
      let cond = {
        AA_CD: this.selectedPosAaCd,
        RAKUSATU_SYUPPIN: this.flgHNv == 'HIKITORI' ? 2 : 1,
        TODO_CD: this.selectedPosTodoCd,
      }
      this.$store
        .dispatch('order/getPos', { cond: cond })
        .then((res) => {
          let posList = []
          res.forEach((pos) => {
            pos.pos_detail.forEach((detail) => {
              detail.pos = cloneDeep(pos)
              posList.push(detail)
            })
          })
          this.posList = posList
          this.selectedPosDetailId =
            this.form[`${this.flgHNv}_AA_POS_DETAIL_ID`]
          this.setTableRowClassAndName(this.selectedPosDetailId, this.posList)
          this.isLoadlingPosList = false
        })
        .catch((err) => {
          this._alert(err.message, false)
          this.isLoadlingPosList = false
        })
    },

    /** POS番号一覧の検索条件初期化 */
    setSearchPosCond() {
      if (!this._form) return
      let tabName = this._form[`ACTIVE_${this.flgHNv}_TAB`]
      if (tabName === 'DIRECT') {
        tabName = 'AUCTION'
      }
      this.selectedPosAaCd = this._form[`${this.flgHNv}_${tabName}`].AA_CD
      this.selectedPosTodoCd = this._form[`${this.flgHNv}_${tabName}`].TODO_CD
    },

    /** POS番号情報選択＆反映 */
    selectedPos() {
      this.form[`${this.flgHNv}_AA_POS_BANGO`] = this.selectedObj.pos.POS_BANGO
      this.form[`${this.flgHNv}_AA_POS_DETAIL_ID`] = this.selectedObj.ID
      this.form[`${this.flgHNv}_AA_POS_KBN`] = this.selectedObj.POS_KBN
      this.form[`${this.flgHNv}_AA_POS_RAKUSATU_SYUPPIN`] =
        this.selectedObj.RAKUSATU_SYUPPIN
      this.form[`${this.flgHNv}_AA_POS_DAIKO_GYOSHA_MEI`] =
        this.selectedObj.DAIKO_GYOSHA_MEI
      this.form[`${this.flgHNv}_AA_POS_MEIGI_INFO`] =
        this.selectedObj.MEIGI_INFO
      this.showPosListDialog = false
    },

    /** POS番号更新 */
    async updatePos() {
      if (!(await this.$refs.posObserver.validate())) return

      let pos = cloneDeep(this.editPosDetail.pos)
      let posDetail = cloneDeep(this.editPosDetail)
      delete posDetail.pos
      delete posDetail.selected
      pos.pos_detail = [posDetail]
      this.showEditPosDialog = false

      return this.$store
        .dispatch('order/updatePos', pos)
        .then((res) => {
          this.showPosListDialog = true
          this.getPos()
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },

    /** 引取先代行業者用POS番号設定イベント */
    setHikiDaikoGyosyaPosBango() {
      if (this.form.HIKITORI_AA_POS_KBN !== 4 || !this.hikiAaCd) return
      const auction = this.getParam(this.posAaList, this.hikiAaCd)
      if (!auction) return
      this.form.HIKITORI_AA_POS_BANGO =
        this.form.HIKITORI_AA_WANPULA_FLG == 1
          ? auction.AS_ONE_POS
          : auction.AS_POS
      this.form.HIKITORI_AA_POS_MEIGI_INFO = 'オートサーバー落札'
    },

    /** 履歴からPOS番号が一意に定まるのであれば入力欄に自動反映する */
    setPos(aaCd, hikiNoName) {
      if (this.form[`${hikiNoName}_AA_POS_BANGO`]) return
      let cond = {
        AA_CD: aaCd,
        RAKUSATU_SYUPPIN: hikiNoName == 'HIKITORI' ? 2 : 1,
        POS_KBN: this.form[`${hikiNoName}_AA_POS_KBN`],
      }
      this.$store
        .dispatch('order/getPos', { cond: cond })
        .then((pos) => {
          if (pos.length !== 1) return
          if (pos[0].pos_detail.length !== 1) return
          this.form[`${hikiNoName}_AA_POS_BANGO`] = pos[0].POS_BANGO
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },

    /** 日曜選択不可 */
    disabledDate(date) {
      if (!this.isMeihen) return false
      return date.getDay() === 0
    },
  },

  computed: {
    /** モーダル編集用のPOS種別 */
    modalPosKbnList() {
      return this.posKbnList.filter((v) => v.value !== 3)
    },

    /** 納車希望日が土曜日か判定する */
    isNosyaSaturday() {
      return this.isWeekDay(this.form.HANNYU_KIBOU_BI, '土')
    },

    /** 名変輸送か判定 */
    isMeihen() {
      return this._form.MEIHEN_FLG
    },

    /** 引取AA開催日 */
    hikitoriAAKaisaibi: {
      get() {
        return this.form.HIKITORI_AA_KAISAI_BI
          ? new Date(this.form.HIKITORI_AA_KAISAI_BI)
          : null
      },
      set(newVal) {
        this.form.HIKITORI_AA_KAISAI_BI = this.dateObjToStr(newVal)
      },
    },

    /** 引取AAワンプラ落札日 */
    hikitoriAAWanpulaRakusatubi: {
      get() {
        return this.form.HIKITORI_AA_WANPULA_RAKUSATU_BI
          ? new Date(this.form.HIKITORI_AA_WANPULA_RAKUSATU_BI)
          : null
      },
      set(newVal) {
        this.form.HIKITORI_AA_WANPULA_RAKUSATU_BI = this.dateObjToStr(newVal)
      },
    },

    /** 引取AA入金予定日 */
    hikitoriAANyukinYoteibi: {
      get() {
        return this.form.HIKITORI_AA_NYUKIN_YOTEI_BI
          ? new Date(this.form.HIKITORI_AA_NYUKIN_YOTEI_BI)
          : null
      },
      set(newVal) {
        this.form.HIKITORI_AA_NYUKIN_YOTEI_BI = this.dateObjToStr(newVal)
      },
    },

    /** 納車AA開催日 */
    nosyaAAKaisaibi: {
      get() {
        return this.form.NOSYA_AA_KAISAI_BI
          ? new Date(this.form.NOSYA_AA_KAISAI_BI)
          : null
      },
      set(newVal) {
        this.form.NOSYA_AA_KAISAI_BI = this.dateObjToStr(newVal)
      },
    },

    /** 搬出希望日 */
    hansyutuKiboubi: {
      get() {
        return this.form.HANSYUTU_KIBOU_BI
          ? new Date(this.form.HANSYUTU_KIBOU_BI)
          : null
      },
      set(newVal) {
        this.form.HANSYUTU_KIBOU_BI = this.dateObjToStr(newVal)
      },
    },

    /** 搬入希望日 */
    hannyuKiboubi: {
      get() {
        return this.form.HANNYU_KIBOU_BI
          ? new Date(this.form.HANNYU_KIBOU_BI)
          : null
      },
      set(newVal) {
        this.form.HANNYU_KIBOU_BI = this.dateObjToStr(newVal)
      },
    },

    isRequiredHansyutuken() {
      return [POS_KBN.SIGMANET, POS_KBN.JU_TRADE].includes(
        this.form.HIKITORI_AA_POS_KBN
      )
    },
  },

  watch: {
    /** 入力データセットフラグ */
    isSetData() {
      this.makeForm()
    },

    /** 入力データ取得フラグ監視 */
    async isGetData(val) {
      if (val) {
        const result = (await this.observer.validate()) ? this.cleanup() : false
        this.$emit('setInvalid', result)
      }
    },

    /** 選択した引取先オークションコード監視 */
    hikiAaCd(aaCd) {
      if (this.isLease) return
      this.setHikiDaikoGyosyaPosBango()
      this.setPos(aaCd, 'HIKITORI')
    },

    /** 選択した納車先オークションコード監視 */
    nosyaAaCd(aaCd) {
      if (this.isLease) return
      this.setPos(aaCd, 'NOSYA')
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
#order-remark button
  background: #28a745 !important

.section-wrapper
  background: $baseGrayColor
  padding: 1%
  overflow: scroll
  @include sp
    max-height: 500px

#template-save-modal
  z-index: 12

section#order-auction,
section#order-hansyutu,
section#order-remark,
div.edit_pos_dialog,
  table
    margin: 0
    th
      background: $baseBlueColor
      color: #fff
      width: 32%
    td
      width: 68%
      background: #fff
</style>



// WEBPACK FOOTER //
// src/components/order/HikiNoDetail.vue